var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.computedClass },
    [
      _c(
        "JadeLabel",
        {
          attrs: {
            error: _vm.error,
            optional: _vm.optional,
            disabled: _vm.disabled,
            hidden: _vm.hideLabel,
            htmlFor: _vm.label,
          },
        },
        [_vm._v(" " + _vm._s(_vm.label) + " ")]
      ),
      _c(
        "select",
        {
          attrs: {
            id: _vm.label,
            "arial-label": _vm.label,
            "arial-required": !_vm.optional,
            disabled: _vm.disabled,
          },
          on: {
            change: ($event) => _vm.$emit("onChange", $event.target.value),
          },
        },
        [
          _c("option", { attrs: { hidden: "", value: "" } }, [
            _vm._v(" " + _vm._s(_vm.placeholder) + " "),
          ]),
          _vm._l(_vm.options, function (option) {
            return _c(
              "option",
              {
                key: _vm.isString(option) ? option : `${option.value}-option`,
                attrs: {
                  "aria-selected": _vm.optionValue(option) === _vm.defaultValue,
                  disabled: _vm.isString(option) ? false : option.disabled,
                },
                domProps: {
                  selected: _vm.optionValue(option) === _vm.defaultValue,
                  value: _vm.optionValue(option),
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.isString(option) ? option : option.label) +
                    " "
                ),
              ]
            )
          }),
        ],
        2
      ),
      _c(
        "JadeSupportText",
        { attrs: { error: _vm.error, disabeld: _vm.disabled } },
        [_vm._v(" " + _vm._s(_vm.supportText) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }